// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"905":"ecab1d69","988":"e6c111ee"}[chunkId] + ".chunk.css";
};